export const ru = {
    'company-period-time': 'время проведения кампании',
    'days-setting': 'Количество дней: {limit}',
    'days-setting-changed': 'Количество дней: {oldLimit} {newLimit}',
    'shows-setting': 'Ограничение показов: {limit}',
    'shows-setting-changed': 'Ограничение показов: {oldLimit} {newLimit}'
};
